import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import {
  ShareCanvasCallable,
  ShareFileRecordCallable,
} from "@/action-dialog/callables";
import type { Canvas, FileRecord } from "@cohesive/api-client";

export interface ShareCanvasParams {
  canvas: Canvas;
}

export function runShareCanvasWorkflow(
  params: ShareCanvasParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    ShareCanvasCallable.call({ canvas: params.canvas }),
  );
}

export interface ShareFileRecordParams {
  record: FileRecord;
}

export function runShareFileRecordWorkflow(
  params: ShareFileRecordParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    ShareFileRecordCallable.call({ record: params.record }),
  );
}
